import { MkRadiusConstants } from "../constants/mkradius.constants";

const MkRadiusReducer = (state, action) => {
  switch (action.type) {
    case MkRadiusConstants.FETCH_MK_RADIUS_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case MkRadiusConstants.FETCH_MK_RADIUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        mkRadiuses: action.payload.data,
        paging: action.payload.paging,
      };
    case MkRadiusConstants.FETCH_MK_RADIUS_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case MkRadiusConstants.MK_RADIUS_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case MkRadiusConstants.MK_RADIUS_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        mkRadiusSearchResults: action.payload,
      };
    case MkRadiusConstants.MK_RADIUS_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case MkRadiusConstants.MK_RADIUS_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case MkRadiusConstants.MK_RADIUS_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        mkRadiusAutoSearchResults: action.payload,
      };
    case MkRadiusConstants.MK_RADIUS_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case MkRadiusConstants.ADD_MK_RADIUS_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case MkRadiusConstants.ADD_MK_RADIUS_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case MkRadiusConstants.ADD_MK_RADIUS_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case MkRadiusConstants.GET_MK_RADIUS_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case MkRadiusConstants.GET_MK_RADIUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        mkRadius: action.payload,
      };
    case MkRadiusConstants.GET_MK_RADIUS_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case MkRadiusConstants.UPDATE_MK_RADIUS_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case MkRadiusConstants.UPDATE_MK_RADIUS_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        mkRadius: action.payload,
      };
    case MkRadiusConstants.UPDATE_MK_RADIUS_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };
    case MkRadiusConstants.DOWNLOAD_MK_RADIUS_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case MkRadiusConstants.DOWNLOAD_MK_RADIUS_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case MkRadiusConstants.DOWNLOAD_MK_RADIUS_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case MkRadiusConstants.UPLOAD_MK_RADIUS_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case MkRadiusConstants.UPLOAD_MK_RADIUS_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case MkRadiusConstants.UPLOAD_MK_RADIUS_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };

    default:
      return state;
  }
};

export default MkRadiusReducer;
